const productActions = {
  LOADING: "LOADING",
  GET_PRODUCTS_SUCCESS: "GET_PRODUCTS_SUCCESS",
  ERROR: "ERROR",
};

export { productActions };
